import { OnInit, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { of } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap, catchError, tap, finalize } from 'rxjs/operators';
import { UtilService } from '@app/shared/utils';
import { OccurencesService } from '@app/occurences/occurences.service';
import { SnackbarService } from '@app/shared/services/snackbar.service';
export var TypeSearch;
(function (TypeSearch) {
    TypeSearch["Name"] = "NAME";
    TypeSearch["Code"] = "CODE";
    TypeSearch["CnpjCpf"] = "CNPJ_CPF";
})(TypeSearch || (TypeSearch = {}));
var OccurenceDataComponent = /** @class */ (function () {
    function OccurenceDataComponent(utils, fb, occurenceService, _snackbarService) {
        this.utils = utils;
        this.fb = fb;
        this.occurenceService = occurenceService;
        this._snackbarService = _snackbarService;
        this.statusDemanda = null;
        this.value = 0;
        this.selectedPortfolio = new EventEmitter();
        this.mySelectNameField = new FormControl();
        this.mySelectCodeField = new FormControl();
        this.mySelectCnpjCpfField = new FormControl();
        this.isLoading = false;
        this.isLoadingPending = new Array();
        this.showLoading = false;
        this.showPortfolios = true;
        this.havePortfolios = false;
        this.isChangeObject = false;
    }
    OccurenceDataComponent.prototype.ngOnInit = function () {
        this.isValueAutoComplete = false;
        this.isAutoCompletCalled = false;
        if (this.isVisualization) {
            this.statusDemanda = this.dataForm.get('statusDemanda').value;
            this.disableFields();
        }
        else {
            this.initMySelectNameField();
            this.initMySelectCodeField();
            this.initMySelectCnpjCpfField();
        }
    };
    OccurenceDataComponent.prototype.initMySelectNameField = function () {
        var _this = this;
        this.mySelectNameField.valueChanges
            .pipe(debounceTime(1000), distinctUntilChanged(), tap(function () {
            _this.threatInitializePortfoliosRequest(TypeSearch.Name);
        }), switchMap(function (value) {
            _this.isChangeObject = false;
            _this.showPortfolios = true;
            return _this.validatePortfoliosRequest(value, TypeSearch.Name);
        })).subscribe(function (wallets) {
            if (_this.showPortfolios === true) {
                _this.filteredOptions = wallets;
            }
        });
    };
    OccurenceDataComponent.prototype.initMySelectCodeField = function () {
        var _this = this;
        this.mySelectCodeField.valueChanges
            .pipe(debounceTime(1000), distinctUntilChanged(), tap(function () {
            _this.threatInitializePortfoliosRequest(TypeSearch.Code);
        }), switchMap(function (value) {
            _this.isChangeObject = false;
            _this.showPortfolios = true;
            return _this.validatePortfoliosRequest(value, TypeSearch.Code);
        })).subscribe(function (wallets) {
            if (_this.showPortfolios === true) {
                _this.filteredOptions = wallets;
            }
        });
    };
    OccurenceDataComponent.prototype.initMySelectCnpjCpfField = function () {
        var _this = this;
        this.mySelectCnpjCpfField.valueChanges
            .pipe(debounceTime(1000), distinctUntilChanged(), tap(function () {
            _this.threatInitializePortfoliosRequest(TypeSearch.CnpjCpf);
        }), switchMap(function (value) {
            _this.isChangeObject = false;
            _this.showPortfolios = true;
            return _this.validatePortfoliosRequest(value, TypeSearch.CnpjCpf);
        })).subscribe(function (wallets) {
            if (_this.showPortfolios === true) {
                _this.filteredOptions = wallets;
            }
        });
    };
    //tslint:disable-next-line: use-life-cycle-interface
    OccurenceDataComponent.prototype.ngOnChanges = function () {
        if (!this.isVisualization) {
            this.threatNotFoundPortfolio(true);
        }
    };
    OccurenceDataComponent.prototype.threatInitializePortfoliosRequest = function (typeSearch) {
        this.dataForm.get('fName').setValue(document.getElementById('mySelectNameField').value);
        this.dataForm.get('fCode').setValue(document.getElementById('mySelectCodeField').value);
        this.dataForm.get('fCpfCnpj').setValue(document.getElementById('mySelectCnpjCpfField').value);
        this.filteredOptions = [];
        this.isLoading = true;
        this.havePortfolios = true;
        if (this.isValueAutoComplete && !this.isAutoCompletCalled) {
            this.isValueAutoComplete = false;
            this.isAutoCompletCalled = false;
            this.cleanSelectsAutoComplet(typeSearch);
        }
        this.isAutoCompletCalled = false;
    };
    OccurenceDataComponent.prototype.cleanSelectsAutoComplet = function (typeSearch) {
        if (this.formWasSubmited) {
            return;
        }
        if (typeSearch !== TypeSearch.CnpjCpf) {
            this.mySelectCnpjCpfField.reset();
        }
        if (typeSearch !== TypeSearch.Code) {
            this.mySelectCodeField.reset();
        }
        if (typeSearch !== TypeSearch.Name) {
            this.mySelectNameField.reset();
        }
    };
    OccurenceDataComponent.prototype.cleanObjects = function () {
        this.filteredOptions = [];
        this.isLoadingPending.splice(this.isLoadingPending.indexOf(true), this.isLoadingPending.length - 1);
        this.havePortfolios = true;
        this.showPortfolios = false;
        this.isLoading = false;
        this.isChangeObject = true;
    };
    OccurenceDataComponent.prototype.threatFinalizePortfoliosRequest = function () {
        this.isLoading = false;
        this.isLoadingPending.shift();
        if (this.isLoadingPending.length > 0) {
            this.isLoading = true;
        }
        if ((Array.isArray(this.filteredOptions) && this.filteredOptions.length > 0) ||
            (this.isLoadingPending.length > 0 || this.isChangeObject)) {
            this.havePortfolios = true;
        }
        else {
            this.havePortfolios = false;
        }
    };
    OccurenceDataComponent.prototype.validatePortfoliosRequest = function (params, typeSearch) {
        var _this = this;
        if (params && typeof params === 'string' && params.trim().length > 2) {
            this.isLoadingPending.push(true);
            return this.occurenceService.getPortfoliosBySearch(String(params), typeSearch).pipe(finalize(function () {
                _this.isAutoCompletCalled = true;
                _this.threatFinalizePortfoliosRequest();
            }), catchError(function (err) {
                return of([]);
            }));
        }
        else {
            return this.threatInvalidPortfoliosRequest(params);
        }
    };
    OccurenceDataComponent.prototype.threatInvalidPortfoliosRequest = function (param) {
        this.isLoading = false;
        return of([]);
    };
    OccurenceDataComponent.prototype.threatNotFoundPortfolio = function (disableNamePortfolio) {
        if (disableNamePortfolio) {
            if (!this.formWasSubmited) {
                this.mySelectNameField.setValue(null);
                this.mySelectCnpjCpfField.setValue(null);
                this.mySelectCodeField.setValue(null);
            }
            this.dataForm.get('fName').setValue(null);
            this.dataForm.get('fCpfCnpj').setValue(null);
            this.dataForm.get('fCode').setValue(null);
        }
        else {
            this.dataForm.get('fName').setValue(this.mySelectNameField.value);
            this.mySelectNameField.setValue(this.dataForm.get('fName').value);
        }
    };
    OccurenceDataComponent.prototype.getField = function (fieldName) {
        return this.dataForm.get(fieldName);
    };
    OccurenceDataComponent.prototype.fieldIsValid = function (fieldName) {
        var field = this.getField(fieldName);
        return field.invalid && (this.mySelectCnpjCpfField.dirty || this.mySelectCnpjCpfField.touched || this.mySelectNameField.dirty || this.mySelectNameField.touched);
    };
    OccurenceDataComponent.prototype.onlyNumbers = function (num) {
        var er = /[^\d]+/g;
        er.lastIndex = 0;
        if (er.test(num)) {
            num = num.replace(/[^\d]+/g, '');
        }
        return num;
    };
    OccurenceDataComponent.prototype.selectPortfolio = function (event) {
        var objSelected = event.option.value;
        //TO DO criar um método separado para validar cpf vindo da base
        if (objSelected) {
            this.isValueAutoComplete = true;
            if (objSelected.name && objSelected.cnpj && objSelected.code && objSelected.id && !OccurencesService.cpfCnpjValidator(objSelected.cnpj)) {
                this.utils.setValuePropertyHTML('mySelectNameField', '');
                this.utils.setValuePropertyHTML('mySelectCnpjCpfField', '');
                this.utils.setValuePropertyHTML('mySelectCodeField', '');
                objSelected = '';
                this.showLoading = false;
                this._snackbarService.showSnackbar('Carteira selecionada possui CNPJ/CPF inválido.', 'OK');
            }
            if (objSelected.name) {
                this.utils.setValuePropertyHTML('mySelectNameField', objSelected.name);
                this.dataForm.get('fName').setValue(objSelected.name);
            }
            if (objSelected.cnpj) {
                this.utils.setValuePropertyHTML('mySelectCnpjCpfField', objSelected.cnpj);
                this.dataForm.get('fCpfCnpj').setValue(objSelected.cnpj);
            }
            if (objSelected.code) {
                this.utils.setValuePropertyHTML('mySelectCodeField', objSelected.code);
                this.dataForm.get('fCode').setValue(objSelected.code);
            }
            if (objSelected.id) {
                this.dataForm.get('fundNumber').setValue(objSelected.id);
            }
            this.showLoading = false;
        }
    };
    OccurenceDataComponent.prototype.getOptionLabel = function (option) {
        if (option) {
            return option.name;
        }
    };
    OccurenceDataComponent.prototype.disableFields = function () {
        //Autocomplete
        this.mySelectNameField.disable();
        this.mySelectCodeField.disable();
        this.mySelectCnpjCpfField.disable();
        //Form
        this.dataForm.get('fName').disable();
        this.dataForm.get('fCpfCnpj').disable();
        this.dataForm.get('fCode').disable();
    };
    return OccurenceDataComponent;
}());
export { OccurenceDataComponent };
